import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./BankingDetails.css";
import HomeLeft from "../Components/HomeLeft";
import HomeRight from "../Components/HomeRight";
import mufg from './assets/mufg.png';
import yenicon from './assets/yenPoster.png';
import dollaricon from './assets/dollarPoster.png';
import paypalPoster from './assets/paypalPoster.png';

const BankingDetails = () => {
    return (
        <>
            <div className="row">
                {/* Middle Column */}
                <div className="col-lg-12 col-md-12 col-sm-12 middlecol">
                    <div className="container banking-details">
                        <p className="text-center mt-3">
                            <strong>
                                Please note that the banking details provided below are the only official banking information
                                associated with SAAD MOTORS (THAILAND) CO.,LTD. We do not hold or use any other banking accounts. SAAD MOTORS (THAILAND) CO.,LTD will not be held responsible for any transactions or communications outside of
                                these details.
                            </strong>
                        </p>
                        <div className="text-center my-3">
                            <img src={mufg} alt="mufg" className="mufg-image img-fluid" />
                        </div>

                        {/* YEN ACCOUNT DETAILS */}
                        <div className="bank-section">
                            <img src={yenicon} alt="yenicon" className="yenicon-image img-fluid" />
                            <p>Beneficiary Banking Details (International Wire Transfers)</p>
                            <p>Kindly find the Complete Banking Details as below & do ensure the same banking details while transfer</p>
                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td>BANK NAME</td>
                                        <td>KASIKORN BANK PUBLIC COMPANY</td>
                                    </tr>
                                    <tr>
                                        <td>BANK NAME</td>
                                        <td>SAAD MOTORS (THAILAND) CO.,LTD</td>
                                    </tr>
                                    <tr>
                                        <td>ACCOUNT NUMBER</td>
                                        <td>236-8-38477-4</td>
                                    </tr>
                                    <tr>
                                        <td>BRANCH CODE</td>
                                        <td>TESCO LOTUS CHAI 2 (RAMA 2 RD)</td>
                                    </tr>
                                    <tr>
                                        <td>BRANCH NAME</td>
                                        <td>SAAD MOTORS CO,. LTD</td>
                                    </tr>
                                    <tr>
                                        <td>BRANCH ADDRESS</td>
                                        <td>99/8 RAMA 2 RD. THA SAI MUANG SAMUT SAKHON 74000</td>
                                    </tr>
                                    <tr>
                                        <td>SWIFT CODE</td>
                                        <td>KASITHBK</td>
                                    </tr>
                                </tbody>
                            </table>
                            <p>******ADDITIONAL INFORMATION INCASE YOUR BANK REQUESTS FOR IT*******</p>
                            <h3 className="text-center">INTERMEDIARY BANKING DETAILS</h3>
                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td>BANK NAME</td>
                                        <td>KASIKORN BANK PUBLIC COMPANY</td>
                                    </tr>
                                    <tr>
                                        <td>BRANCH NAME</td>
                                        <td>TESCO LOTUS CHAI 2 (RAMA 2 RD)</td>
                                    </tr>
                                    <tr>
                                        <td>BRANCH ADDRESS</td>
                                        <td>99/8 RAMA 2 RD. THA SAI MUANG SAMUT SAKHON 74000</td>
                                    </tr>
                                    <tr>
                                        <td>SWIFT CODE</td>
                                        <td>KASITHBK</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* USD ACCOUNT DETAILS */}

                    </div>
                </div>
            </div>
        </>
    );
};

export default BankingDetails;
